import React from "react";
import "./Loader.css";

const Loader = () => {
  return (
    <div className="loader-container">
      <svg
        className="qs-logo"
        viewBox="0 0 900 400"
        xmlns="http://www.w3.org/2000/svg"
      >
        <text
          x="50%"
          y="60%"
          textAnchor="middle"
          dominantBaseline="middle"
          className="qs-text"
        >
          QuickSeva
        </text>
      </svg>
    </div>
  );
};

export default Loader;